import type { ClientIntent, SeatRequest } from '@tctp/protocol';
import { Modal } from './Modal';

/** PokerNow's join-request dialog for the host: one request at a time, oldest first. */
export function JoinRequestModal({ request, act, onIgnore }: { request: SeatRequest; act: (intent: ClientIntent) => Promise<void>; onIgnore: () => void }) {
  const sit = request.kind === 'sit';
  const title = `The player "${request.nickname}" wants to ${sit ? 'join the game' : 'top up'}!`;
  return (
    <Modal title={title} onClose={onIgnore}>
      <div className="field-box">
        <label>{sit ? 'Intended Stack' : 'Top-up Amount'}<input type="number" value={request.amount} readOnly /></label>
        {sit && <p className="muted">Seat {request.seat + 1}</p>}
      </div>
      <div className="modal-actions">
        <button type="button" className="btn red" onClick={() => void act({ type: 'deny', requestId: request.id })}>REJECT</button>
        <button type="button" className="btn red" onClick={onIgnore}>IGNORE</button>
        <button type="button" className="btn green" onClick={() => void act({ type: 'approve', requestId: request.id })}>ACCEPT</button>
      </div>
    </Modal>
  );
}
